import { render, staticRenderFns } from "./VolunteerRedpoint.vue?vue&type=template&id=22bc727a&scoped=true&"
import script from "./VolunteerRedpoint.vue?vue&type=script&lang=js&"
export * from "./VolunteerRedpoint.vue?vue&type=script&lang=js&"
import style0 from "./VolunteerRedpoint.vue?vue&type=style&index=0&id=22bc727a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bc727a",
  null
  
)

export default component.exports